import { useEffect, useState } from 'react';

export const useTextCrop = ({ threeLinesHeight }) => {
    const [contentRef, setContentRef] = useState(undefined);
    const [showCropped, setShowCropped] = useState(false);
    const [initiated, setInitiated] = useState(false);

    const { clientHeight } = contentRef || {};

    useEffect(() => {
        if (!clientHeight || initiated) return;

        setShowCropped(clientHeight > threeLinesHeight);
        setInitiated(true);
    }, [clientHeight, initiated, threeLinesHeight]);

    return {
        showCropped,
        contentRef,
        setContentRef,
        setShowCropped,
    };
};
